/**
 * Where the design's "Policy" button goes.
 *
 * The artboard puts the policy panel in a drill-down's sidebar and a "Policy"
 * button in the run screen's header, and never draws the button's
 * destination. This is it: the same panel, over the whole window rather than
 * one offer's partner, with the window's filters above it so "the policy as it
 * applied last month" is a question that can be asked.
 *
 * It is a thin screen on purpose. The panel is the content, it is shared with
 * the drill-down, and a second layout of the same facts would be a second
 * thing to keep true.
 */

import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Error from '../../../Components/Error';
import useDecisionFeed, { windowLabel } from './useDecisionFeed';
import DecisionFilters from './Components/DecisionFilters';
import PolicyInForce from './Components/PolicyInForce';

function PolicyPage() {
  const [error, setError] = useState('');
  const feed = useDecisionFeed({ onError: setError });

  return (
    <div className="partner-sync auto-approval">
      <Link className="auto-approval-back" to="/partner-sync">← Back to the queue</Link>

      <div className="auto-approval-head">
        <div className="auto-approval-head-main">
          <div className="auto-approval-eyebrow">Partner sync</div>
          <h1 className="auto-approval-title">The policy</h1>
          <p className="auto-approval-intro">
            What the agent is allowed to approve on its own, per partner. Read
            back off the decisions it took — the flag as it stood at the time,
            and the thresholds its rules measured against.
          </p>
        </div>
      </div>

      <Error error={error} setError={setError} />

      <DecisionFilters feed={feed} />

      {feed.isLoading ? (
        <div className="text-center my-5 py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted mt-3 mb-0">Reading the policy off the decisions…</p>
        </div>
      ) : (
        <div className="auto-approval-policy-page">
          <PolicyInForce
            rows={feed.rows}
            partners={feed.partners}
            heading={`The policy, as the ${windowLabel(feed.sinceDays)} shows it`}
          />
        </div>
      )}
    </div>
  );
}

export default PolicyPage;
